<template>
  <div class="banner" :class="{'banner-pc':!isMobile,'banner-m':isMobile}">
    <div class="wave-content">
      <div class="banner-center">
        <div class="bg-circle">
          <div>
            <img src="../assets/images/img/BTY1@2x.png" />
            <p>BitYuan</p>
          </div>
          <div class="more">
            <a target="_blank" href="https://www.bityuan.com/index">了解更多</a>
          </div>
          <div class="bg-hide"></div>
        </div>
        <div class="circle-box" v-for="(item,index) in btyMsg" :key="index">
          <div class="circle flex-center">
            <div class="first-circle flex-center">
              <div class="second-circle flex-center">
                <p>{{item.index}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="detail detail-one">
          <p>当前总量</p>
          <span></span>
          <p class="totalNum">{{parseInt(totalSum)}} BTY</p>
        </div>
        <div class="detail detail-two">
          <span></span>
          <p>当前总市值</p>
          <p class="totalNum">{{parseInt(totalValue)}} CNY</p>
        </div>
        <div class="detail detail-three">
          <span></span>
          <p>当前交易笔数</p>
          <p class="totalNum">{{parseInt(txCount)}} 笔</p>
        </div>
      </div>
      <div class="wave-box">
        <div class="waveWrapper waveAnimation">
          <div class="waveWrapperInner bgMiddle">
            <div class="wave waveMiddle"></div>
          </div>
          <div class="waveWrapperInner bgBottom">
            <div class="wave waveBottom"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBTYmsg } from "@/assets/js/api.js";
import Base64 from "@/assets/js/base64.js";
export default {
  data() {
    return {
      isMobile: false,
      btyMsg: [
        {
          index: "01"
        },
        {
          index: "02"
        },
        {
          index: "03"
        }
      ],
      totalSum: 320377328,
      BTYValue: 0,
      txCount: 10256528,
      getNewPrice: 0
    };
  },
  computed: {
    totalValue() {
      return this.totalSum * this.BTYValue;
    },
    newHash() {
      return this.$store.state.maxHash;
    },
    endHeight() {
      return this.$store.state.maxHeight;
    }
  },
  watch: {
    newHash(hash) {
      this.hexCharCodeToStr(hash);
    }
  },
  mounted() {
    this.isMobile = this.$store.state.isMobile;
    this.getBTY("BTY");
    this.hexCharCodeToStr(this.newHash);
    this.getNewPrice = setInterval(() => {
      this.getBTY("BTY");
    }, 10000);
  },
  methods: {
    //获取BTY单价
    getBTY(symbol) {
      getBTYmsg(symbol).then(data => {
        if (data.code === 0) {
          this.BTYValue = data.data[0].rmb;
        }
      });
    },
    //获取BTY交易总数
    getBTYtradeSum(hash) {
      this.$chain33Rpc.queryTotalFee([`${hash}`]).then(data => {
        if (data.error === null) {
          // 2270000分叉区块，收益30 --> 8
          this.totalSum =
            this.endHeight > 2269999
              ? 367369978 + 8 * this.endHeight - data.result.fee / 100000000
              : 317430000 + 30 * this.endHeight - data.result.fee / 100000000;
          this.txCount = data.result.txCount;
        } else {
          this.$notify({
            title: "提示",
            message: data.error,
            type: "warning"
          });
        }
      });
    },
    //16进制转换
    // var str = "A";
    // str.charCodeAt();  // 65
    // var num = 97;
    // String.fromCharCode(num);  // 'a'
    hexCharCodeToStr(hexCharCodeStr) {
      let num = hexCharCodeStr;
      let trimedStr = num.trim();
      let rawStr =
        trimedStr.substr(0, 2).toLowerCase() === "0x"
          ? trimedStr.substr(2)
          : trimedStr;
      let len = rawStr.length;
      if (len % 2 !== 0) {
        alert("Illegal Format ASCII Code!");
        return "";
      }
      let curCharCode;
      let resultStr = [];
      for (var i = 0; i < len; i = i + 2) {
        curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
        resultStr.push(String.fromCharCode(curCharCode));
      }
      //转码ASCII——base64
      var b = new Base64();
      var str = b.encode(`TotalFeeKey:${resultStr.join("")}`);
      this.getBTYtradeSum(str);
    }
  },
  beforeDestroy() {
    clearInterval(this.getNewPrice);
  }
};
</script>

<style lang="scss" scoped>
// pc
.banner-pc {
  .banner-center {
    width: 1000px;
    height: 560px;
    margin-top: -95px;
    padding-top: 95px;
    .bg-circle {
      width: 530px;
      height: 530px;
      margin: 0 auto;
      border: 6px transparent solid;
      div:nth-of-type(1) {
        z-index: 3;
        position: relative;
        width: 250px;
        height: 250px;
        margin: 120px auto 15px;
      }
      img:nth-of-type(1) {
        margin-top: 70px;
      }
      p {
        margin-top: 10px;
        font-size: 18px;
        color: #686868;
      }
      .more {
        width: 100px;
        height: 30px;
        line-height: 30px;
        color: #333;
        a {
          width: 100px;
          height: 30px;
        }
      }
      .more:hover {
        border: 1px solid #fff;
        a {
          color: #fff;
        }
      }
    }
    .bg-hide {
      height: 190px;
    }
    .circle {
      width: 100px;
      height: 100px;
    }
    .first-circle {
      width: 85px;
      height: 85px;
    }
    .second-circle {
      width: 65px;
      height: 65px;
      font-size: 30px;
    }
    .circle-box:nth-of-type(2) {
      top: -320px;
      left: 190px;
    }
    .circle-box:nth-of-type(3) {
      top: -580px;
      left: 350px;
    }
    .circle-box:nth-of-type(4) {
      top: -320px;
      left: 510px;
    }
    .detail {
      width: 180px;
      p:nth-of-type(1) {
        margin: 0 8px 5px;
        font-size: 16px;
      }
      p:nth-of-type(2) {
        font-size: 18px;
      }
    }
    .detail-one {
      left: 40px;
      top: -390px;
    }
    .detail-two {
      top: -730px;
      left: 560px;
    }
    .detail-three {
      top: -490px;
      left: 825px;
    }
  }
  .waveWrapper {
    height: 100px;
  }
  .waveWrapperInner {
    height: 100px;
    min-width: 1300px;
  }
  .waveMiddle {
    background-size: 50% 120px;
  }
  .waveBottom {
    background-size: 50% 100px;
  }
}

//适配移动
.banner-m {
  .banner-center {
    width: 100vw;
    height: 76vw;
    .bg-circle {
      width: 71vw;
      height: 71vw;
      margin: 14vw 0 0 15vw;
      display: inline-block;
      border: 2px transparent solid;
      div:nth-of-type(1) {
        z-index: 3;
        position: relative;
        width: 50vw;
        height: 50vw;
        margin: 5vw auto 0;
        background-size: 30vw 30vw;
        background-repeat: no-repeat;
        background-position: center;
      }
      img:nth-of-type(1) {
        width: 9vw;
        height: 11.5vw;
        margin-top: 17vw;
      }
      p {
        margin-top: 1vw;
        font-size: 14px;
        font-weight: 600;
        color: #686868;
      }
      .more {
        width: 20vw;
        height: 7vw;
        line-height: 7vw;
        color: #333;
        a {
          color: #fff;
        }
      }
    }
    .bg-hide {
      height: 32vw;
    }
    .circle {
      width: 16vw;
      height: 16vw;
    }
    .first-circle {
      width: 12vw;
      height: 12vw;
    }
    .second-circle {
      font-size: 16px;
      width: 8vw;
      height: 8vw;
    }
    .circle-box:nth-of-type(2) {
      top: -45vw;
      left: 7vw;
    }
    .circle-box:nth-of-type(3) {
      top: -80vw;
      left: 26vw;
    }
    .circle-box:nth-of-type(4) {
      top: -45vw;
      left: 46vw;
    }
    .detail {
      width: 29vw;
      display: inline-block;
      p:nth-of-type(1) {
        margin: 0 1.5vw 1vw;
        font-size: 3.5vw;
      }
      p:nth-of-type(2) {
        font-size: 3vw;
      }
    }
    .detail-one {
      top: -27vw;
      left: -47vw;
    }
    .detail-two {
      top: -96vw;
      left: 58vw;
    }
    .detail-three {
      width: 26vw;
      top: -43vw;
      left: 45vw;
    }
  }
  .waveWrapper {
    height: 20vw;
  }
  .waveWrapperInner {
    height: 20vw;
  }
  .waveMiddle {
    background-size: 50% 70px;
  }
  .waveBottom {
    background-size: 50% 60px;
  }
}
</style>

<!-- 公共颜色部分 -->
<style lang="scss">
.banner .bg-circle div:nth-of-type(1) {
  background-image: url("../assets/images/img/circleW.png") !important;
}
.banner {
  background-image: linear-gradient(#181618 95%, #27262b);
  .wave-content .bg-circle div:nth-of-type(1) {
    background: url("../assets/images/img/circleB.png") no-repeat center center;
  }
  .bg-hide {
    background: #181618;
  }
  .circle {
    background: #22201e;
  }
  .totalNum {
    color: #fff;
  }

  .banner-center {
    margin: 0 auto;
    .bg-circle {
      border-radius: 50%;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: radial-gradient(#181618, #181618),
        radial-gradient(#27262a 60%, #191819 70%, #050505 72%);
      text-align: center;
      .more {
        position: relative;
        z-index: 11;
        margin: 0 auto;
        border-radius: 30px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        background: $black_font_light;
      }
    }
    .bg-hide {
      z-index: 2;
      margin-top: -75px;
      width: 100%;
    }
    .first-circle {
      margin: auto;
      background: rgba(237, 217, 165, 0.2);
    }
    .second-circle {
      color: #1c1a1c;
      background: #edd9a5;
    }
    .circle,
    .first-circle,
    .second-circle {
      border-radius: 50%;
    }
    .circle-box {
      display: inline-block;
      position: relative;
    }
    .detail {
      position: relative;
      text-align: left;
      span {
        border-left: 1px solid $black_font_gray;
      }
      p:nth-of-type(1) {
        display: inline-block;
        color: $black_font_light;
      }
    }
  }

  //波浪背景
  @keyframes move_wave {
    0% {
      transform: translateX(0) translateZ(0) scaleY(1);
    }
    50% {
      transform: translateX(-25%) translateZ(0) scaleY(0.55);
    }
    100% {
      transform: translateX(-50%) translateZ(0) scaleY(1);
    }
  }
  .waveWrapper {
    overflow: hidden;
    margin: auto;
  }
  .waveWrapperInner {
    position: absolute;
    width: 100%;
    overflow: hidden;
  }
  .bgMiddle {
    z-index: 10;
    opacity: 0.75;
  }
  .bgBottom {
    z-index: 5;
  }
  .wave {
    position: absolute;
    left: 0;
    width: 200%;
    height: 100%;
    background-repeat: repeat no-repeat;
    background-position: 0 bottom;
    transform-origin: center bottom;
  }
  .waveAnimation {
    animation: move-wave 3s;
    -webkit-animation: move-wave 3s;
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }
  .waveMiddle {
    background-image: url("../assets/images/img/wave1.png");
  }
  .waveAnimation .waveMiddle,
  .waveAnimation .waveMiddle2 {
    animation: move_wave 10s linear infinite;
  }
  .waveBottom {
    background-image: url("../assets/images/img/wave2.png");
  }
  .waveAnimation .waveBottom,
  .waveAnimation .waveBottom2 {
    animation: move_wave 15s linear infinite;
  }
}
</style>